export default () => ({
  root: {
    backgroundColor: 'rgba(20, 23, 86, 0.9)',
    height: '100vh'
  },
  flipbook: {
    height: 'calc(100vh - 200px)'
  },
  title: {
    marginLeft: 20
  }
});
